export default __webpack_public_path__ + "static/media/ic_report_problem.4c272def.svg";